"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reservation() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="501" id="conversionbanddiscretion" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[60vh] lg:min-h-[80vh]">
        {}
        <div ref={leftRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/luxury_sedan_fleet.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/luxury_sedan_fleet.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/luxury_sedan_fleet.png-wvc-sizes" alt="Professional chauffeur standing by a luxury sedan" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" src="http://bemaxlimo.com/wp-content/uploads/2026/07/2FC7D6BB-73A9-408E-8EA8-EE870EF8EF74.png" src="http://bemaxlimo.com/wp-content/uploads/2026/07/0B871A94-7010-467B-9FDF-BF563F431E19-2.webp" src="http://bemaxlimo.com/wp-content/uploads/2026/07/IMG_3205.png" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(0, 0%, 0%, 0.9) 0%, hsla(0, 0%, 2%, 0.8) 50%, hsla(0, 0%, 7%, 0.7) 100%)",
          opacity: 0.85
        }} />
          <div className="absolute inset-0 bg-black/20" />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 right-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 right-0 w-px bg-white/20" />
            <div className="absolute right-0 h-24 w-px bg-[#C0C0C0] opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500" />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 text-[#C0C0C0]">
                Our Fleet
              </p>
              <h2 className="font-default font-light leading-[1.05] tracking-tight text-white mb-6" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)"
            }}>
                Refined travel
              </h2>
              <p className="text-base sm:text-lg text-white/80 leading-relaxed mb-10 max-w-md">
                Experience the pinnacle of comfort with our curated selection of premium vehicles. Every journey is defined by elegance and precision.
              </p>
              <Button asChild size="lg" className="rounded-lg px-8 py-6 h-auto text-base font-medium transition-transform duration-300 hover:scale-105 shadow-lg bg-[#C0C0C0] text-black hover:bg-white">
                <Link to="/FleetPage">
                  View Fleet
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        backgroundColor: "#E6E6E6"
      }}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_service_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_service_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_service_interior.png-wvc-sizes" alt="Interior of a luxury chauffeured vehicle" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" src="http://bemaxlimo.com/wp-content/uploads/2026/07/2FC7D6BB-73A9-408E-8EA8-EE870EF8EF74.png" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(0, 0%, 90%, 0.9) 0%, hsla(0, 0%, 80%, 0.8) 100%)"
        }} />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 left-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-px bg-black/20" />
            <div className="absolute left-0 h-24 w-px opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500 bg-[#000000]" />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 text-[#000000]">
                Reservations
              </p>
              <h2 className="font-default font-light leading-[1.05] tracking-tight mb-6 text-[#050505]" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)"
            }}>
                Secure your ride
              </h2>
              <p className="text-base sm:text-lg leading-relaxed mb-10 max-w-md text-[#111111]">
                Book your private chauffeur service with ease. Our team is ready to provide a seamless, professional experience tailored to your schedule.
              </p>
              <Button asChild size="lg" className="rounded-lg px-8 py-6 h-auto text-base font-medium transition-transform duration-300 hover:scale-105 shadow-lg bg-[#000000] text-white hover:bg-[#111111]">
                <Link to="/SecureChauffeurPage">
                  Reserve Now
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tide {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(100%); }
        }
      `}</style>
    </section>;
}